import { useEffect, useState } from 'react';
import { ReadOnlyInputText } from '../ui/Inputs';
import { BsCalendar4Range } from 'react-icons/bs';
import { PrimaryTextColor } from '../../app/theme/tokens/colors';
import styled from 'styled-components';
import { Calendar } from 'react-calendar';
import { formatDate } from '../../utils/date';

const formatRange = (range) =>
    Array.isArray(range) && range[0] && range[1]
        ? `${formatDate(range[0])} - ${formatDate(range[1])}`
        : '';

const getRangeKey = (range) =>
    Array.isArray(range)
        ? range.map((date) => (date instanceof Date ? date.getTime() : date ?? '')).join(':')
        : '';

const CustomSelectDiv = styled.div`
  position: fixed;
  background-color: white;
  box-sizing: border-box;
  border: none;
  box-shadow: rgb(207 207 207) 0px 1px 5px;
  font-size: 14px;
  border-radius: 10px;
  overflow-y: auto;
  margin-top: 5px;
  z-index: 20000;
  color: ${(props) => props.fontColor};
`;
export const DateRange = ({
    minDetail,
    maxDate,
    maxDetail,
    height,
    style,
    onSelect,
    selectRange,
    showFixedNumberOfWeeks,
    minDate,
    checkDateAvailability,
    initialRange,
}) => {
    const [value, setValue] = useState([]);
    const [valueS, setValueS] = useState('');
    const [errS, setErrS] = useState('');
    const [openValues, setOpenValues] = useState(false);
    const initialRangeKey = getRangeKey(initialRange);

    useEffect(() => {
        if (!Array.isArray(initialRange) || !initialRange[0] || !initialRange[1]) {
            return;
        }

        setValue([...initialRange]);
        setValueS(formatRange(initialRange));
    }, [initialRange, initialRangeKey]);

    const reset = () => {
        setOpenValues(false);
        setErrS('');
    };
    const selectValue = (value) => {
        if (!selectRange) {
            if (typeof onSelect === 'function') {
                setValue(value);
                setErrS('');
                setValueS(`${formatDate(value)}`);
                onSelect(value);
                setOpenValues(false);
                return;
            }
        }
        const delta = value[1].getTime() - value[0].getTime();
        const days = delta / (1000 * 3600 * 24); //dias
        if (days > 365) {
            setErrS(`O período máximo é de 12 meses`);
            setValue([]);
        } else {
            setValue([...value]);
            setErrS('');
            setValueS(`${formatDate(value[0])} - ${formatDate(value[1])}`);
            if (typeof onSelect === 'function') {
                onSelect(value);
            }
            setOpenValues(false);
        }
    };
    return (
        <div style={{ ...style, position: 'relative', boxSizing: 'border-box' }}>
            <BsCalendar4Range
                onClick={() => setOpenValues(!openValues)}
                style={{
                    position: 'absolute',
                    top: '7px',
                    right: '7px',
                    color: PrimaryTextColor,
                    fontSize: '26px',
                    cursor: 'pointer',
                }}
            />
            <ReadOnlyInputText
                disabled
                value={valueS}
                style={{
                    color: '#000',
                    cursor: 'pointer',
                    width: '100%',
                    boxSizing: 'border-box',
                    border: 'solid 1px #c9c9c9',
                    padding: '5px',
                    textIndent: '0px',
                    paddingLeft: '6px',
                    paddingRight: '45px',
                    height: height ?? 'auto',
                }}
            ></ReadOnlyInputText>
            {openValues ? (
                <CustomSelectDiv
                    className="custom-calendar"
                    fontColor={PrimaryTextColor}
                    onMouseLeave={() => reset()}
                >
                    <div
                        style={{
                            display: 'inline-flex',
                            padding: '10px',
                            boxSizing: 'border-box',
                            textAlign: 'center',
                        }}
                    >
                        <div>
                            {errS !== '' ? (
                                <p style={{ fontWeight: '600', color: 'red' }}>{errS}</p>
                            ) : (
                                <></>
                            )}
                            <Calendar
                                maxDetail={maxDetail}
                                locale="pt"
                                minDetail={minDetail ?? 'year'}
                                onChange={selectValue}
                                showFixedNumberOfWeeks={showFixedNumberOfWeeks ?? true}
                                selectRange={selectRange ?? true}
                                maxDate={maxDate}
                                minDate={minDate}
                                tileDisabled={checkDateAvailability}
                            ></Calendar>
                        </div>
                    </div>
                </CustomSelectDiv>
            ) : (
                <></>
            )}
        </div>
    );
};
